import * as React from 'react';
import Container from '@material-ui/core/Container';
import { Grid } from '@material-ui/core';
import NavMenu from './NavMenu';
import AlertSnackbar from './AlertSnackbar'
import { actionCreators } from '../store/AlertSnackbarStore'
import { ErrorBoundary } from 'react-error-boundary'
import { useDispatch } from 'react-redux';
import { getAppInsights } from '../common/TelemetryService'
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import useBreadcrumbs, { BreadcrumbData } from 'use-react-router-breadcrumbs';
import { NavLink } from 'react-router-dom';
import { validate } from 'uuid'
import * as R from 'ramda'

/** main site layout
 * show the navmenu above everything. The main container uses the largest breakpoint so that it is the full width on desktop
 */
export default function Layout(props: { children?: React.ReactNode }) {
    const dispatch = useDispatch()
    const breadcrumbs = useBreadcrumbs()
    // https://www.npmjs.com/package/react-error-boundary
    const myErrorHandler = (error: Error, info: { componentStack: string }) => {
        getAppInsights()?.trackException({ exception: error, severityLevel: SeverityLevel.Error })
        dispatch(actionCreators.addError(error))
    }
    const fallback = (e: { error: Error }) => (
        <div role='alert'>
            <p>Something went wrong. This issue has been logged</p>
            <pre>{e.error.message}</pre>
        </div>
    )

    return (
        <>
            <NavMenu />
            <Container maxWidth='xl'>
                <Grid container spacing={1}>
                    <Grid item xs={1}>{/** TODO: add sidebar navigation here */}</Grid>
                    <Grid item xs={10}>
                        {breadcrumbs.length > 1 && [(<span key={breadcrumbs[0].match.url}><NavLink to={breadcrumbs[0].match.url}>{breadcrumbs[0].breadcrumb}</NavLink></span>),
                        ...breadcrumbs.slice(1) //seems a bit silly to show Home link on the home page
                            .map(({ match, breadcrumb }, index) =>
                                (index === breadcrumbs.length - 2 && validate(R.last(match.url.split('/')) ?? ''))
                                    ? (<React.Fragment key={match.url}></React.Fragment>) // don't show the final thing if it's an id
                                    : (<span key={match.url}> / <NavLink to={match.url}>{breadcrumb}</NavLink></span>))]}
                        <ErrorBoundary FallbackComponent={fallback} onError={myErrorHandler}>
                            {props.children}
                        </ErrorBoundary>
                        <AlertSnackbar />
                    </Grid>
                    <Grid item xs={1}></Grid>
                </Grid>
            </Container>
        </>
    )
}
